import { Injectable } from '@angular/core';

import { delay, Observable, of, share } from 'rxjs';
import {
  getTransactionChartsMock, getTransactionMetricsMock, getTransactionsMock,
} from '@pt/mocks';

import { GetMetricsReq, GetMetricsRes, GetTransactionsReq, GetTransactionsRes } from '../models';
import { TransactionsApi } from './transactions-api.interface';

@Injectable()
export class TransactionsApiMockService implements TransactionsApi {
  getMetrics(params: GetMetricsReq): Observable<GetMetricsRes> {
    const metrics = getTransactionMetricsMock(params.forTeam);
    return of(metrics).pipe(delay(500), share());
  }

  getTransactions(params: GetTransactionsReq): Observable<GetTransactionsRes> {
    const transactions = getTransactionsMock(params.forTeam, 24);
    const charts = getTransactionChartsMock(params.forTeam, 4);
    return of({ charts, transactions, itemsCount: transactions.length })
      .pipe(delay(500), share());
  }
}
